import audioUploader from './audioUploader.module'
import spreadsheetUploader from './spreadsheetUploader.module'

export default {
  audioUploader,
  spreadsheetUploader,
}
